import { createContext, useContext } from 'react';
import { User } from '@/types/auth';

interface SessionUserContextValue {
  user: User | null;
}

export const SessionUserContext = createContext<SessionUserContextValue>({ user: null });

export const useSessionUser = () => useContext(SessionUserContext);
